import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import './assets/css/style.css';



function App() {

 return (
  <div className="App">
  <Router basename="/">
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/About-qube-art" element={<About />} />
      <Route path="/Contact" element={<Contact />} />
   
    </Routes>
  </Router>
</div>
 )

}

export default App